module.exports = __webpack_public_path__ + "static/img/banner3.38266ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/banner3.png
// module id = IJ8+
// module chunks = 0